import { render } from "./paymentExplanationModal.html?vue&type=template&id=7ed2bb73&scoped=true&ts=true&external"
import script from "./PaymentExplanationModal.vue?vue&type=script&lang=ts"
export * from "./PaymentExplanationModal.vue?vue&type=script&lang=ts"

import "./PaymentExplanationModal.vue?vue&type=style&index=0&id=7ed2bb73&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ed2bb73"]])

export default __exports__